import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["settlementFields"];

  connect() {
    this.toggle();
  }

  toggle() {
    // 파트너/협력사 모두 정산 정보 표시
    const selectedRole = this.element.querySelector(
      'input[name="user[role]"]:checked',
    )?.value;
    const show = selectedRole === "partner" || selectedRole === "affiliate";

    this.settlementFieldsTarget.style.display = show ? "block" : "none";
  }
}
